import { GENERAL_IDENTIFIERS } from '../../types/Identifiers';
import { identifyCustomTag } from '../custom/identify-custom-tag';
import PROPS from '../../types/Props';
export var filterDuplicateCustomTags = function (a, b) {
    return a.filter(function (tagA) {
        if (!tagA.custom || !b.length) {
            return true;
        }
        var tagAIdentifier = identifyCustomTag(tagA);
        if (!tagAIdentifier) {
            return false;
        }
        return !b.some(function (tagB) {
            var tagBIdentifier = identifyCustomTag(tagB);
            if (tagBIdentifier === tagAIdentifier) {
                switch (tagBIdentifier) {
                    case GENERAL_IDENTIFIERS.LINK:
                        return tagA.props[PROPS.REL] === tagB.props[PROPS.REL];
                    case GENERAL_IDENTIFIERS.OG_TAG:
                        return tagA.props[PROPS.PROPERTY] === tagB.props[PROPS.PROPERTY];
                    case GENERAL_IDENTIFIERS.SATANDARD_META:
                        return tagA.props[PROPS.NAME] === tagB.props[PROPS.NAME];
                    default:
                        return false;
                }
            }
            return false;
        });
    });
};
